import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { DefinitionsFacade } from './definitions.facade';

export const DowngradedDefinitionsDomainModule = angular
  .module('downgraded-definitions-domain', [])
  .service('DefinitionsFacade', downgradeInjectable(DefinitionsFacade)).name;
